'use client';
import React, { useEffect, useState } from 'react';
import moment from 'jalali-moment';
import ProductTimer from '../share/productTimer';

export default function SpTimer({ start, end }) {
  const [remainingTime, setRemainingTime] = useState(0);

  useEffect(() => {
    const endMoment = moment(end);
    const nowMoment = moment();
    const startMoment = moment(start);

    if (nowMoment.isAfter(startMoment)) {
      const diffInSeconds = endMoment.diff(nowMoment, 'seconds');

      if (diffInSeconds > 0 && diffInSeconds <= 432000) {
        setRemainingTime(diffInSeconds);
      } else {
        setRemainingTime(0);
      }
    } else {
      setRemainingTime(0);
    }
  }, [start, end]);

  return (
    <>
      {remainingTime > 0 && (
        <div className="flex absolute top-2 items-center z-10 justify-between w-full max-w-[350px] mx-auto right-0 left-0">
          <div className="text-primary-900 font-bold text-xs">
            زمان باقی‌مانده تخفیف:
          </div>
          <ProductTimer initialTime={remainingTime} />
        </div>
      )}
    </>
  );
}
